export default "__VITE_ASSET__D5bsW2v7__"